import { fireLinkTag } from './tagManager';

type Payload = {
  videoTimeViewed: number;
  videoDuration: number;
  data: {
    video_id: string[];
    product_id: string[];
    product_name: string[];
  };
};
type TagType = 'start' | 'pause';

export default function tagVideo({ videoTimeViewed, videoDuration, data }: Payload, tagType: TagType) {
  switch (tagType) {
    case 'start':
      // MCOM sometimes provides a small float (e.g., 0.06) instead of 0
      if (videoTimeViewed <= 0.1) {
        fireLinkTag({
          event_name: 'video start',
          link_name: 'video start',
          video_merch: 'video played',
          ...data,
        });
      }
      break;
    case 'pause':
      fireLinkTag({
        event_name: 'video pause',
        link_name: 'video pause',
        video_duration: [`${videoDuration}`],
        video_time_viewed: [videoTimeViewed.toString()],
        ...data,
      });
      break;
    default:
  }
}
